import type { RegisterPasskeyError } from '../types';

export const isRegisterPasskeyError = (e: unknown): e is RegisterPasskeyError =>
  (e as RegisterPasskeyError)?.kind === 'registerPasskeyError';

/**
 * Extracts the underlying error and timing from a potential RegisterPasskeyError.
 */
export const unwrapPasskeyError = (error: unknown): { cause: unknown; elapsedTimeInOsPromptMs?: number } => {
  if (isRegisterPasskeyError(error)) {
    return { cause: error.error, elapsedTimeInOsPromptMs: error.elapsedTimeInOsPromptMs };
  }
  return { cause: error };
};
